import { useQuery } from '@tanstack/react-query';
import { getAppDetail } from '@api/appManagement';

const staleTime = 300000;
const AppManagementQueryKey = ['get-app-clientId', 'ei'];

export interface AppInfo {
  title: string;
  description?: string;
  inactive?: boolean;
  clientId?: string;
  clientSecret?: string;
  customerId?: number;
  createdByUserId?: number;
  updatedByUserId?: number;
}

export const useAppDetails = (clientId: string) => {
  const response = useQuery(
    AppManagementQueryKey,
    () => {
      return getAppDetail<AppInfo>(clientId);
    },
    {
      retry: 3,
      refetchOnWindowFocus: false,
      staleTime: staleTime, // 3m
    },
  );

  return response;
};
